import { type ListingProduct, ListingProductCode } from 'src/generated/graphql';

import { getConfigValues } from '../../config';

import type { DesktopFeatures } from './desktop';
import type { listingProductsFreemium } from './freemium/products';
import type { MobileFeatures } from './mobile';

export const isFreemiumExperiment = getConfigValues().IS_FREEMIUM_EXPERIMENT;

type ListingPackageInfo = {
  productCode: ListingProduct['productCode'];
  description: string;
  features: {
    desktop: DesktopFeatures;
    mobile: MobileFeatures;
  };
};

export const isFreemium = (productCode: ListingProductCode) =>
  productCode === ListingProductCode.Freemium;
export const isStandard = (productCode: ListingProductCode) =>
  isFreemiumExperiment && productCode === ListingProductCode.ListUntilSold;
export const isAccelerate = (productCode: ListingProductCode) =>
  productCode === ListingProductCode.Accelerate;

export const listingProducts = [
  {
    productCode: ListingProductCode.SixAdPack,
    description: 'Advertise your business for 6 months',
    features: {
      desktop: {
        price: 'enabled',
        refresh: 'enabled',
        tools: 'enabled',
        duration: 'disabled',
        boostedAds: 'addOn450',
      },
      mobile: {
        calculator: { enabled: true },
        checklist: { enabled: true },
        edit: { enabled: true },
        price: { enabled: true },
        refresh: { enabled: true },
        screening: { enabled: true },
        boostedAds: { enabled: true, label: 'Promote your ad (add-on*)' },
        duration: { enabled: true, label: 'Advertise for 6 months' },
      },
    },
  },
  {
    productCode: ListingProductCode.ListUntilSold,
    description: "Advertise your business until it's sold",
    features: {
      desktop: {
        duration: 'enabled',
        price: 'enabled',
        refresh: 'enabled',
        tools: 'enabled',
        boostedAds: 'addOn650',
      },
      mobile: {
        calculator: { enabled: true },
        checklist: { enabled: true },
        edit: { enabled: true },
        price: { enabled: true },
        refresh: { enabled: true },
        screening: { enabled: true },
        boostedAds: { enabled: true, label: 'Promote your ad (add-on*)' },
        duration: { enabled: true, label: 'Advertise until sold' },
      },
    },
  },
  {
    productCode: ListingProductCode.PayPerEnquiry,
    description: 'Pay only for enquiries you receive',
    features: {
      desktop: {
        price: 'payPerEnquiry',
        duration: 'enabled',
        boostedAds: 'enabled',
        refresh: 'enabled',
        tools: 'enabled',
      },
      mobile: {
        calculator: { enabled: true },
        checklist: { enabled: true },
        edit: { enabled: true },
        price: { enabled: true },
        refresh: { enabled: true },
        screening: { enabled: true },
        boostedAds: { enabled: true, label: 'Promote your ad' },
        duration: { enabled: true, label: 'Advertise until sold' },
      },
    },
  },
] satisfies ListingPackageInfo[];

export interface ListingProductWithPackageInfo extends ListingProduct {
  productCode:
    | (typeof listingProducts)[number]['productCode']
    | (typeof listingProductsFreemium)[number]['productCode'];
}
